let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("55qHL")).then(() => parcelRequire('5YglT'));